module.exports = __webpack_public_path__ + "img/e1bcdb7edbb3f8e960fc165a31bfe81d.png";